"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThirdSectionWrap = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.ThirdSectionWrap = styled_components_1.default.section `
  gap: 96px;

  ul {
    gap: 97px;
    align-items: center;
    justify-content: center;

    li {
      position: relative;

      div {
        display: flex;
        flex-direction: column;
        font-family: Inter, sans-serif;
        font-size: 16px;
        font-weight: 500;
        line-height: 19px;
        padding: 12px;
        gap: 4px;
        border-radius: 18px;
        background-color: #ffffff;
        z-index: 2;

        h3 {
          font-weight: 700;
          color: #7b4ef8;
          margin: 0;
        }

        p {
          margin: 0;
          font-weight: 500;
          color: #333333;
        }
      }

      img {
        position: absolute;
        z-index: -1;
      }

      &.landing-third-section-children {
        max-width: 293px;
        transform: translateX(-10px);

        img {
          width: 119px;
          height: 183px;

          top: -92px;
          left: -19px;
        }
      }

      &.landing-third-section-parents {
        max-width: 295px;
        transform: translateX(-8px);

        img {
          top: -92px;
          right: -17px;
          width: 205px;
          height: 355px;
        }
      }

      &.landing-third-section-therapists {
        max-width: 276px;
        transform: translateX(18px);
        margin-top: 40px;

        img {
          width: 125px;
          height: 309px;

          top: -94px;
          left: -38px;
        }
      }
    }
  }

  @media screen and (min-width: 768px) {
    gap: 16px;
    padding-bottom: 43px;

    ul {
      gap: 24px;

      li {
        div {
          font-size: 16px;
          font-weight: 500;
          line-height: 19px;
          padding: 20px 23px;
          gap: 12px;
          border-radius: 18px;

          h3 {
            font-size: 24px;
            line-height: 29px;
            font-weight: 700;
          }
        }

        &.landing-third-section-children {
          max-width: 442px;
          transform: translateX(-6px);
          z-index: 1;

          img {
            width: 159px;
            height: 244px;

            top: -43px;
            left: -148px;
          }
        }

        &.landing-third-section-parents {
          max-width: 418px;
          transform: translateX(20px);
          z-index: 0;

          img {
            top: -138px;
            right: -143px;
            width: 230.73px;
            height: 402.6px;
          }
        }

        &.landing-third-section-therapists {
          max-width: 520px;
          transform: translateX(0);
          margin-top: 0;

          img {
            width: 168px;
            height: 407px;

            top: -169px;
            left: -109px;
          }
        }
      }
    }
  }

  @media screen and (min-width: 1000px) {
    ul {
      li {
        &.landing-third-section-children {
          transform: translateX(-44px);
        }

        &.landing-third-section-parents {
          transform: translateX(59px);
        }

        &.landing-third-section-therapists {
          transform: translateX(-44px);
        }
      }
    }
  }

  @media screen and (min-width: 1300px) {
    gap: 53px;
    padding-bottom: 121px;

    ul {
      gap: 90px;

      li {
        div {
          font-size: 27px;
          font-weight: 500;
          line-height: 33px;
          padding: 30px;
          gap: 12px;
          border-radius: 35px;

          h3 {
            font-size: 27px;
            line-height: 33px;
          }
        }

        &.landing-third-section-children {
          max-width: 669px;
          transform: translateX(-5px);
          z-index: 1;

          img {
            width: 305px;
            height: 469px;

            top: -84px;
            left: -262px;
          }
        }

        &.landing-third-section-parents {
          max-width: 718px;
          transform: translateX(10px);
          z-index: 0;

          img {
            top: -208px;
            right: -265px;
            width: 443px;
            height: 773px;
          }
        }

        &.landing-third-section-therapists {
          max-width: 826px;
          margin-top: 44px;
          transform: translateX(10px);

          img {
            width: 322px;
            height: 782px;

            top: -325px;
            left: -195px;
          }
        }
      }
    }
  }

  @media screen and (min-width: 1690px) {
    gap: 53px;
    padding-bottom: 154px;

    ul {
      gap: 123px;

      li {
        &.landing-third-section-children {
          max-width: 820px;
          transform: translateX(0px);
          z-index: 1;

          img {
            width: 305px;
            height: 469px;
          }
        }

        &.landing-third-section-parents {
          max-width: 789px;
          transform: translateX(-25px);
          z-index: 0;

          img {
            top: -208px;
            right: -325px;
            width: 443px;
            height: 773px;
          }
        }

        &.landing-third-section-therapists {
          max-width: 958px;
          transform: translateX(10px);
        }
      }
    }
  }

  @media screen and (min-width: 1920px) {
    gap: 46px;
    padding-bottom: 0;

    ul {
      gap: 24px;

      li {
        div {
          font-size: 36px;
          line-height: 44px;
          padding: 40px 45px;
          gap: 25px;
          border-radius: 35px;

          h3 {
            font-size: 36px;
            line-height: 44px;
          }
        }

        &.landing-third-section-children {
          max-width: 983px;
          transform: translateX(-16px);
          z-index: 1;

          img {
            width: 305px;
            height: 469px;

            top: -84px;
            left: -284px;
          }
        }

        &.landing-third-section-parents {
          max-width: 932px;
          transform: translateX(19px);
          z-index: 0;

          img {
            top: -208px;
            right: -307px;
            width: 443px;
            height: 773px;
          }
        }

        &.landing-third-section-therapists {
          max-width: 1037px;
          margin-top: 0;
          transform: translateX(-84px);

          img {
            width: 322px;
            height: 782px;
            top: -325px;
            left: -209px;
          }
        }
      }
    }
  }
`;
